import { useState, Fragment } from "react"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import toolTipIcon from "@/public/icons/dimension-tooltip.svg"
import { dimensionsTooltipAnalyticsData } from "@/components/ProductDetail/v3/ProductAccordionList/analytics"

const RowData = ({ data, accordionType, productInfo, config = {} }) => {
  const [activeTooltipIdx, setActiveTooltipIdx] = useState(-1)

  const { regexPattern: { map: { productDimensionsRegex = "" } } = {} } = config

  const removeSpecialChars = str => {
    const strValue = String(str || "")
    const regex = new RegExp(productDimensionsRegex)
    return strValue.replace(regex, "")
  }

  const tooltipHover = (index, message) => {
    setActiveTooltipIdx(index)
    dimensionsTooltipAnalyticsData(accordionType, productInfo, message)
  }

  return (
    <div className="pdp-dimensions__container">
      {data.map((d, index) => {
        return d.value ? (
          <Fragment key={index}>
            <div
              className={`pdp-dimensions__label ${
                index % 2 === 0 ? "pdp-dimensions__highlighted" : ""
              }`}
            >
              <span>{d.label}</span>
              {d.tooltip ? (
                <>
                  <img
                    className="pdp-dimensions__tooltipIcon"
                    src={toolTipIcon?.src}
                    alt={"Tooltip"}
                    onMouseLeave={() => {
                      setActiveTooltipIdx(-1)
                    }}
                    onMouseOver={() => {
                      tooltipHover(index, d.tooltip)
                    }}
                    onBlur={() => {
                      setActiveTooltipIdx(-1)
                    }}
                  />
                  {activeTooltipIdx === index ? (
                    <ToolTip message={d.tooltip} />
                  ) : null}
                </>
              ) : null}
            </div>
            <span
              className={`pdp-dimensions__value ${
                index % 2 === 0 ? "pdp-dimensions__highlighted" : ""
              }`}
            >
              {`${removeSpecialChars(d.value)} ${d?.unit ?? ""}`}
            </span>
          </Fragment>
        ) : null
      })}
    </div>
  )
}

export default RowData
